
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class AcademicInformation extends Vue {
  @Prop(Object) user!: any;
  @Prop(Function) cancelButton!: any;
  @Prop(Function) saveAcademic!: any;
  @Prop(Array) educationLvl!: any;
  @Prop(Array) educationCareer!: any;
  @Prop(Array) educationStatus!: any;
  @Prop(Boolean) withBtn!: boolean;
  hash = Math.random() * 100000;
  getOption() {
    if (this.user.study_level) {
      let num_id =
        typeof this.user.study_level === "object"
          ? this.user.study_level.id
          : parseInt(this.user.study_level);
      (this as any).user.study_level = (this as any).educationLvl.find(
        (i: any) => {
          return i.id === (this as any).user.study_level;
        }
      );
    }
    if (this.user.study_status) {
      let num_id =
        typeof this.user.study_status === "object"
          ? this.user.study_status.id
          : parseInt(this.user.study_status);
      (this as any).user.study_status = (this as any).educationStatus.find(
        (i: any) => {
          return i.id === (this as any).user.study_status;
        }
      );
    }
    if (this.user.study) {
      let num_id =
        typeof this.user.study === "object"
          ? this.user.study.id
          : parseInt(this.user.study);

      (this as any).user.study = (this as any).educationCareer.find(
        (i: any) => {
          return i.id === (this as any).user.study;
        }
      );
    }
  }
  async mounted() {
    this.getOption();
  }

  get academicListByLvl() {
    if (this.user.study_level && this.user.study_level.id) {
      return this.educationCareer.filter((item: any) => {
        return item.parentId === parseInt(this.user.study_level.id);
      });
    } else return [];
  }
}
